/**
 * 后台导航：左侧大板块 + 右侧顶部子任务
 * 权限过滤在 App.vue 中根据 ctx 计算
 */

function pathStarts(routePath, prefix) {
  return routePath === prefix || String(routePath || '').startsWith(prefix + '/')
}

function task(id, label, path, extra) {
  return Object.assign({ id, label, path, query: null }, extra || {})
}

export const NAV_MODULES = [
  {
    id: 'workbench',
    label: '工作台',
    icon: 'el-icon-s-home',
    visible: (ctx) => !ctx.isStaffCashier,
    tasks: [task('dash', '工作台', '/')]
  },
  {
    id: 'cashier',
    label: '收银',
    icon: 'el-icon-shopping-cart-full',
    visible: (ctx) => ctx.canMenuCashier,
    tasks: [
      task('entry', '收银台', '/cashier', { visible: (ctx) => ctx.canMenuCashier })
    ]
  },
  {
    id: 'orders',
    label: '订单',
    icon: 'el-icon-document',
    visible: (ctx) => ctx.hasMenuPerm('订单管理') || ctx.hasMenuPerm('随心订管理'),
    tasks: [
      task('situation', '收银台订单', '/orders/situation', {
        visible: (ctx) => ctx.hasMenuPerm('订单管理')
      }),
      task('sub', '随心订订单', '/orders', {
        query: { tab: 'order' },
        visible: (ctx) => ctx.hasMenuPerm('订单管理') || ctx.hasMenuPerm('随心订管理'),
        match: (route) =>
          route.path === '/orders' && String((route.query && route.query.tab) || 'order') === 'order'
      }),
      task('refund', '退款订单', '/orders', {
        query: { tab: 'refund' },
        visible: (ctx) => ctx.hasMenuPerm('订单管理'),
        match: (route) =>
          route.path === '/orders' && String((route.query && route.query.tab) || '') === 'refund'
      }),
      task('defer', '延期查询', '/deferral-query', {
        visible: (ctx) => ctx.hasMenuPerm('订单管理')
      }),
      task('meal', '随心订排餐', '/meal-holiday-config', {
        visible: (ctx) =>
          (ctx.hasMenuPerm('订单管理') || ctx.hasMenuPerm('随心订管理')) && !ctx.isStaffCashier,
        match: (route) =>
          route.path === '/meal-holiday-config' || route.path === '/subscription-calendar'
      }),
      task('plans', '套餐计划', '/subscriptions', {
        visible: (ctx) => ctx.hasMenuPerm('随心订管理') && !ctx.isStaffCashier
      })
    ]
  },
  {
    id: 'store',
    label: '门店',
    icon: 'el-icon-office-building',
    visible: (ctx) =>
      ((ctx.hasMenuPerm('商品管理') || ctx.hasMenuPerm('随心订管理')) && !ctx.isStaffCashier) ||
      ctx.canMenuCashier ||
      ctx.hasMenuPerm('订单管理'),
    tasks: [
      task('products', '商品管理', '/products', {
        visible: (ctx) => ctx.hasMenuPerm('商品管理'),
        match: (route) => pathStarts(route.path, '/products')
      }),
      task('stores', '店铺管理', '/stores', {
        visible: (ctx) => ctx.hasMenuPerm('商品管理')
      }),
      task('expiry', '效期管理', '/expiry-management', {
        visible: (ctx) => ctx.hasMenuPerm('商品管理')
      }),
      task('inv-dash', '库存仪表盘', '/inventory/dashboard', {
        visible: (ctx) => ctx.hasMenuPerm('商品管理')
      }),
      task('inv-in', '入库日志', '/inventory/inbound-logs', {
        visible: (ctx) => ctx.hasMenuPerm('商品管理')
      }),
      task('inv-out', '出库日志', '/inventory/outbound-logs', {
        visible: (ctx) => ctx.hasMenuPerm('商品管理')
      }),
      task('inv-io', '出入库填报', '/inventory/inout-report', {
        visible: (ctx) => ctx.hasMenuPerm('商品管理')
      }),
      task('groupon-verify', '团购扫码核销', '/groupon-verify', {
        visible: (ctx) => ctx.canMenuCashier || ctx.hasMenuPerm('订单管理')
      })
    ]
  },
  {
    id: 'staff',
    label: '员工',
    icon: 'el-icon-s-custom',
    visible: (ctx) => ctx.hasMenuPerm('员工管理') && !ctx.isStaffCashier,
    tasks: [
      task('list', '员工管理', '/employees'),
      task('review', '审核申请', '/delete-requests-review', {
        visible: (ctx) => ctx.canReviewDelete
      }),
      task('attend', '门店考勤', '/store-attendance'),
      task('calendar', '出勤日历', '/attendance-calendar'),
      task('logs', '操作日志', '/operation-logs')
    ]
  },
  {
    id: 'riders',
    label: '骑手',
    icon: 'el-icon-location-outline',
    visible: (ctx) =>
      (ctx.hasMenuPerm('订单管理') || ctx.hasMenuPerm('骑手管理')) && !ctx.isStaffCashier,
    tasks: [
      task('info', '骑手信息', '/riders/info'),
      task('today', '今日配送', '/riders/today'),
      task('map', '实时地图', '/riders/map')
    ]
  },
  {
    id: 'marketing',
    label: '营销',
    icon: 'el-icon-s-ticket',
    visible: (ctx) =>
      ctx.hasMenuPerm('兑换券管理') ||
      (ctx.hasMenuPerm('随心订管理') && !ctx.isStaffCashier) ||
      (ctx.hasMenuPerm('商品管理') && !ctx.isStaffCashier),
    tasks: [
      task('voucher', '兑换券', '/vouchers', {
        visible: (ctx) => ctx.hasMenuPerm('兑换券管理')
      }),
      task('banner', '轮播图', '/banner-management', {
        visible: (ctx) => ctx.hasMenuPerm('随心订管理') && !ctx.isStaffCashier
      }),
      task('email', '邮件群发', '/email-batch', {
        visible: (ctx) => ctx.hasMenuPerm('商品管理') && !ctx.isStaffCashier
      })
    ]
  },
  {
    id: 'config',
    label: '配置',
    icon: 'el-icon-setting',
    visible: (ctx) =>
      ctx.canMenuCashier ||
      ctx.hasMenuPerm('订单管理') ||
      ((ctx.hasMenuPerm('商品管理') ||
        ctx.hasMenuPerm('随心订管理') ||
        ctx.hasMenuPerm('骑手管理')) &&
        !ctx.isStaffCashier),
    tasks: [
      task('product-mgmt', '商品管理配置', '/config/product-mgmt', {
        visible: (ctx) => ctx.hasMenuPerm('商品管理') && !ctx.isStaffCashier,
        match: (route) => pathStarts(route.path, '/config/product-mgmt')
      }),
      task('portal', '官网门户', '/portal-site', {
        visible: (ctx) => ctx.hasMenuPerm('随心订管理') && !ctx.isStaffCashier
      }),
      task('mini', '小程序设置', '/mini-decoration', {
        visible: (ctx) =>
          (ctx.hasMenuPerm('随心订管理') || ctx.hasMenuPerm('商品管理')) && !ctx.isStaffCashier
      }),
      task('display', '取餐大屏', '/display-config', {
        visible: (ctx) => ctx.hasMenuPerm('订单管理') && !ctx.isStaffCashier
      }),
      task('groupon', '团购核销对接', '/groupon-settings', {
        visible: (ctx) => ctx.canMenuCashier || ctx.hasMenuPerm('订单管理')
      }),
      task('tpl', '映美/飞鹅模板', '/receipt/template', {
        visible: (ctx) =>
          (ctx.hasMenuPerm('订单管理') || ctx.hasMenuPerm('骑手管理')) && !ctx.isStaffCashier
      }),
      task('print', '映美/飞鹅打印', '/receipt/print', {
        visible: (ctx) =>
          (ctx.hasMenuPerm('订单管理') || ctx.hasMenuPerm('骑手管理')) && !ctx.isStaffCashier
      }),
      task('desktop', '桌面版', '/config/desktop', {
        visible: (ctx) => ctx.hasMenuPerm('商品管理') && !ctx.isStaffCashier,
        match: (route) => pathStarts(route.path, '/config/desktop')
      })
    ]
  },
  {
    id: 'member',
    label: '会员',
    icon: 'el-icon-user',
    visible: (ctx) =>
      (ctx.hasMenuPerm('客户管理') && !ctx.isStaffCashier) || ctx.isStaffCashier,
    tasks: [
      task('accounts', '用户管理', '/user-accounts', {
        visible: (ctx) => ctx.hasMenuPerm('客户管理') && !ctx.isStaffCashier
      }),
      task('customers', '客户查询', '/users', {
        visible: (ctx) => ctx.hasMenuPerm('客户管理') && !ctx.isStaffCashier,
        match: (route) => route.path === '/users' || route.path === '/member/users'
      }),
      task('levels', '等级规则', '/member/level-rules', {
        visible: (ctx) => ctx.hasMenuPerm('客户管理') && !ctx.isStaffCashier
      }),
      task('level-logs', '等级日志', '/member/logs', {
        visible: (ctx) => ctx.hasMenuPerm('客户管理') && !ctx.isStaffCashier
      }),
      task('points', '积分商城', '/member/points-mall', {
        visible: () => true
      }),
      task('personal', '个人中心', '/personal', {
        visible: () => true,
        match: (route) => route.path === '/personal'
      })
    ]
  }
]

function taskVisible(item, ctx) {
  if (!item) return false
  if (typeof item.visible === 'function') return !!item.visible(ctx)
  return true
}

function taskMatches(item, route) {
  if (!item || !route) return false
  if (typeof item.match === 'function') return !!item.match(route)
  if (item.query && item.query.tab) {
    return (
      route.path === item.path &&
      String((route.query && route.query.tab) || '') === String(item.query.tab)
    )
  }
  return route.path === item.path
}

export function filterModules(ctx) {
  return NAV_MODULES.map((mod) => {
    const tasks = (mod.tasks || []).filter((t) => taskVisible(t, ctx))
    return Object.assign({}, mod, { tasks })
  }).filter((mod) => taskVisible(mod, ctx) && mod.tasks.length)
}

export function resolveNav(route, modules) {
  const list = Array.isArray(modules) ? modules : []
  for (let i = 0; i < list.length; i++) {
    const mod = list[i]
    const tasks = mod.tasks || []
    for (let j = 0; j < tasks.length; j++) {
      if (taskMatches(tasks[j], route)) {
        return { module: mod, task: tasks[j] }
      }
    }
  }
  let best = null
  let bestLen = -1
  for (let i = 0; i < list.length; i++) {
    const tasks = list[i].tasks || []
    for (let j = 0; j < tasks.length; j++) {
      const p = tasks[j].path
      if (p && p !== '/' && pathStarts(route.path, p) && p.length > bestLen) {
        best = { module: list[i], task: tasks[j] }
        bestLen = p.length
      }
    }
  }
  if (best) return best
  return { module: list[0] || null, task: (list[0] && list[0].tasks && list[0].tasks[0]) || null }
}
